var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m226.427843 11.3391964-8.392064-8.27264771c-.247821-.24429457-.247464-.64002252.000798-.88388313.248262-.2438606.650417-.24350881.898238.00078575l8.392025 8.27260869c.381662.3761653.595193.8549688.64064 1.3459784.021095.0622099.03252.1287728.03252.1979616 0 .0687416-.011278.1348912-.032113.1967548-.044623.4932339-.258802.9743905-.642489 1.3518385l-8.403556 8.2683722c-.248055.2440646-.65021.2440433-.898239-.0000475-.248028-.2440908-.248006-.6398189.000049-.8838835l8.403596-8.2684111c.013144-.0129305.025824-.026145.03804-.0396234h-26.830138c-.350784 0-.63515-.279822-.63515-.625s.284366-.625.63515-.625h26.827189c-.011119-.0121566-.022617-.024096-.034496-.0358036z","fill":"#363e76","transform":"translate(-199 -2)"}));
}

ArrowRightInline.defaultProps = {"height":"20","viewBox":"0 0 29 20","width":"29"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
